(ns iris.websocket.init
  (:require [re-frame.core :as rf]
            [iris.websocket.client :as client]
            [iris.websocket.auth :as auth]
            [iris.websocket.handlers :as handlers]
            [iris.websocket.heartbeat :as heartbeat]
            [iris.websocket.online-users :as online-users]
            [iris.config :as config]))

(defonce reconnect-attempts (atom 0))
(defonce max-reconnect-attempts 10)

;; Register the :ws/send effect
(rf/reg-fx
 :ws/send
 (fn [message]
   (js/console.log "Sending WebSocket message:" message)
   (client/send! message)))

(defn start! []
  (js/console.log "WebSocket init: start! called")
  (rf/dispatch [:iris.websocket/init]))

(rf/reg-event-fx
 :iris.websocket/init
 (fn [{:keys [db]} _]
   (js/console.log "WebSocket init: checking fingerprint..." (:fp db))
   ;; Wait for fingerprint to be ready
   (if (:fp db)
     (do
       (js/console.log "WebSocket init: fingerprint ready, getting token")
       {:dispatch [:iris.websocket.auth/get-token]})
     (do
       (js/console.log "WebSocket init: fingerprint not ready, retrying...")
       {:dispatch-later [{:ms 100 :dispatch [:iris.websocket/init]}]}))))

(rf/reg-event-fx
 :iris.websocket/connect-with-token
 (fn [{:keys [db]} [_ token]]
   (js/console.log "WebSocket init: connecting with token" token)
   (let [ws-url (str config/SOKRATES_WS_URL "/ws")]
     (client/connect!
       ws-url
       token
       (fn [msg] (rf/dispatch [:ws/message-received msg]))
       (fn [] (rf/dispatch [:iris.websocket/disconnected])))
     {})))

(rf/reg-event-fx
 :iris.websocket/connected
 (fn [{:keys [db]} _]
   (js/console.log "WebSocket: connected!")
   (reset! reconnect-attempts 0)
   {:db (assoc-in db [:websocket :status] :connected)
    :dispatch-n [;; [:iris.websocket.heartbeat/start]   ; disabled until app-service is deployed
                 [:iris.websocket/subscribe-broadcast]
                 ;; [:iris.websocket/request-online-users]  ; disabled until needed
                 ]}))

(rf/reg-event-fx
 :iris.websocket/disconnected
 (fn [{:keys [db]} _]
   (js/console.log "WebSocket: disconnected, attempt" @reconnect-attempts)
   (if (< @reconnect-attempts max-reconnect-attempts)
     (do
       (swap! reconnect-attempts inc)
       {:db (assoc-in db [:websocket :status] :disconnected)
        :dispatch-later [{:ms (* 2000 @reconnect-attempts) 
                          :dispatch [:iris.websocket.auth/get-token]}]})
     (do
       (js/console.error "Max reconnection attempts reached")
       {:db (assoc-in db [:websocket :status] :failed)
        ;; :dispatch [:iris.websocket.heartbeat/stop]  ; disabled until heartbeat is re-enabled
        }))))

(rf/reg-event-db
 :iris.websocket/error
 (fn [db [_ error]]
   (js/console.error "WebSocket error:" error)
   (assoc-in db [:websocket :error] error)))

;; Subscription for connection status
(rf/reg-sub
 :iris.websocket/status
 (fn [db _]
   (get-in db [:websocket :status] :disconnected)))

(rf/reg-event-fx
 :iris.websocket/subscribe-broadcast
 (fn [_ _]
   (js/console.log "WebSocket: subscribing to broadcast channel")
   {:ws/send {:type "subscribe" :channel "channel:broadcast"}}))

(rf/reg-event-fx
 :iris.websocket/request-online-users
 (fn [_ _]
   (js/console.log "WebSocket: requesting online users list")
   {:ws/send {:type "get_online_users"}}))